// like !default / !edit / %21viewLogs
import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationViewRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-view',
	path: '/secure/admin/ViewNotificationSchemes([!%]?[\\w]*).jspa',
};
